const Manage = () => import('@/views/system/manage.vue')
const Permissions = () => import('@/views/system/permissions.vue')
const Roles = () => import('@/views/system/roles.vue')
const Config = () => import('@/views/system/config.vue')
const RechargeCard = () => import('@/views/system/recharge-card.vue')
const Banner = () => import('@/views/system/banner.vue')
const Feedback = () => import('@/views/system/feedback.vue')
const LoginLog = () => import('@/views/system/login-log.vue')
const Notice = () => import('@/views/system/notice.vue')
const ArticleHelp = () => import('@/views/system/article-help.vue')
const TaskSiteSwitch = () => import('@/views/system/task-site-switch.vue')

const router = [
  {
    meta: {title: '管理员列表', route: 'manage_index'},
    path: 'smanage',
    name: 'smanage',
    component: Manage
  },
  {
    meta: {title: '系统设置', route: 'config_index'},
    path: 'config',
    name: 'config',
    component: Config
  },
  {
    meta: {title: '充值卡', route: 'recharge_card_index'},
    path: 'recharge-card',
    name: 'recharge-card',
    component: RechargeCard
  },
  {
    meta: {title: '轮播图', route: 'banner_index'},
    path: 'banner',
    name: 'banner',
    component: Banner
  },
  {
    meta: {title: '登录日志', route: 'login_log_index'},
    path: 'login-log',
    name: 'login-log',
    component: LoginLog
  },
  {
    meta: {title: '权限列表', route: 'permissions_index'},
    path: 'permissions',
    name: 'permissions',
    component: Permissions
  },
  {
    meta: {title: '角色管理', route: 'roles_index'},
    path: 'roles',
    name: 'roles',
    component: Roles
  }
]
module.exports = {router};
